import request from '../ajax_request.js'
import {base_url, debug_obj} from "../base_api"


export function sale({params,data}){
	let url = `${base_url}/pos/sale.php`;
	console.log(debug_obj,params)
	return request({
		url,
		method : 'post',
		params:Object.assign({},debug_obj,params?params:{}),
		data
    })
}

export function check_pay_state_3part(query){//weixin_alipy_state{order_id,type}
	let url = `${base_url}/pos/sale.php?oper=scanpay_state`;
	return request({
        url,
        method: 'get',
        params:Object.assign({},debug_obj,query?query:{})
    })
}




// WEBPACK FOOTER //
// ./src/api/module/sale.js